import $ from '../$';
import './eq';
$.fn.last = function () {
    return this.eq(-1);
};
